import React from "react";

import {
    Create,
    DateInput,
    TextInput,
    NumberInput,
    SimpleForm,
    required,
    useNotify,
    useRefresh,
    SelectInput,
    useRedirect,
    ReferenceInput,
} from "react-admin";

import { useCreateStyles } from "../__common/MyStyles";
import { MyCreateActions } from "../__common/MyCreateActions";
import { sleep } from "../../common/js/Functions";

const SamplesCreate = (props) => {
    const classes = useCreateStyles();

    const notify = useNotify();
    const refresh = useRefresh();
    const redirect = useRedirect();

    const onSuccess = ({ data }) => {
        notify(`Sample created, redirecting to "show" view`);
        sleep(2000).then(() => {
            redirect(`/samples/${data.id}/show`);
            refresh();
        });
    };

    const today = new Date();

    return (
        <Create
            {...props}
            title="Create Sample"
            onSuccess={onSuccess}
            submitOnEnter={true}
            actions={<MyCreateActions />}
            classes={classes}
        >
            <SimpleForm>
                {/* <TextInput source="sample" placeholder="Short sample description" /> */}
                <DateInput source="collection_date" defaultValue={today} />
                <TextInput
                    source="description"
                    placeholder="More detailed sample description"
                    minRows={4}
                    multiline
                    resettable
                />
                <TextInput
                    label="Sample code"
                    source="code"
                    validate={required()}
                    placeholder="Unique sample code, example A"
                />
                <NumberInput source="longitude" />
                <NumberInput source="latitude" />
                <SelectInput
                    source="source"
                    choices={[
                        { id: "Water", name: "Water" },
                        { id: "Environment", name: "Environment" },
                        { id: "Health Facilities", name: "Health Facilities" },
                        { id: "Other", name: "Other" },
                    ]}
                />
                <TextInput source="sampling_site" />

                <ReferenceInput
                    perPage={999999} // FIXME: This is a hack to avoid the "perPage" error
                    label="Catalog sample"
                    source="id_catalog_sample"
                    reference="catalog_samples"
                    allowEmpty
                >
                    <SelectInput optionText="short_description" />
                </ReferenceInput>

                <ReferenceInput
                    perPage={999999} // FIXME: This is a hack to avoid the "perPage" error
                    label="Provider"
                    source="id_provider"
                    reference="providers"
                >
                    <SelectInput optionText="name" />
                </ReferenceInput>
                <TextInput
                    fullWidth
                    source="notes"
                    label="Notes"
                    multiline
                    minRows={6}
                />
            </SimpleForm>
        </Create>
    );
};

export default SamplesCreate;
